module.exports = __webpack_public_path__ + "img/dummy3.a319919.jpg";